import { httpService } from './httpService';
import type { Login, ChangePasswordModel } from '../models/login.model';
import { store } from '../reduxToolkit/store';
import { login as reduxLogin } from '../reduxToolkit/reducers/layout/authSlice';
import { ApiResponse } from '../models/ApiResponse';

class LoginService {
  async login(data: Login): Promise<any> {
    try {
      // unwrap = true to directly get `data` instead of `ApiResponse<T>`
      const result = await httpService.post<any>(
        '/api/account/login',
        data,
        undefined,
        { unwrap: true, toast: true }
      );
      // Backend returns { Token, RefreshToken } but other consumers might expect camelCase; normalize here
      const token = result.token || result.Token;
      const refreshToken = result.refreshToken || result.RefreshToken;
      if (token) {
        store.dispatch(reduxLogin({ token, refreshToken }));
      }
      return result;
    } catch (error) {
      console.error('Login API error:', error);
      throw error;
    }
  }

  async changePassword(data: ChangePasswordModel): Promise<ApiResponse<ChangePasswordModel>> {
    try {
      // unwrap = false to return full ApiResponse
      return await httpService.post<ChangePasswordModel>(
        '/api/account/change-password',
        data,
        undefined,
        { unwrap: false, toast: true }
      );
    } catch (error) {
      console.error('Change Password API error:', error);
      throw error;
    }
  }
}

export const loginService = new LoginService();
